<template>
  <v-card>
    <v-toolbar v-if="!add" flat class="overflow-x-auto flex-wrap-nowrap">
      <template v-if="to || toSupplier">
        <v-btn
          v-if="
            (Fees && access.create_fee) ||
            (Customers && access.create_customer) ||
            (EmployeesAccess && access.create_access) ||
            (Employees && access.create_employee) ||
            (InventorySuplier && access.create_supplier) ||
            (InventoryProduction && access.create_production) ||
            (InventoryCount && access.create_inv_count) ||
            (InventoryStock && access.create_stock_adjustmen) ||
            (InventoryTransfer && access.create_transfer) ||
            (InventoryPurchase && access.create_purchase) ||
            (Itemss && access.create_good_sale) ||
            (invPurchaseMark && access.create_mark) ||
            PromotionsItemsDiscount
          "
          class="mr-1"
          tile
          color="success"
          v-bind:to="link('create')"
        >
          <v-icon color="white">mdi-plus</v-icon>
          <div class="text-color">
            {{ $t(`${add_button_name}`) }}
          </div>
        </v-btn>
      </template>
      <v-dialog
        v-else-if="create && !itemsMark"
        v-model="dialog"
        persistent
        v-bind:width="dialogWidth"
      >
        <template #activator="{ on }">
          <v-btn
            v-if="
              (SettingsDevice && access.create_pos_device) ||
              (invanStore && access.create_store) ||
              SettingsOptions ||
              SettingsButton ||
              (SettingsTaxe && access.create_taxes) ||
              (EmployeesTimeCard && access.create_time_card) ||
              (ItemDiscount && access.create_discount) ||
              (ItemModifier && access.create_modifier) ||
              ClientStatus
            "
            class="mr-1"
            tile
            color="success"
            v-on="on"
            :disabled="!(!Buttons || (Buttons && data.length < 6))"
            v-on:click="
              () => {
                typing(null);
              }
            "
          >
            <v-icon>mdi-plus</v-icon>
            {{ $t(`${add_button_name}`) }}
          </v-btn>
        </template>
        <v-card tile>
          <v-card-text />
          <slot />
          <v-card-actions>
            <v-btn
              v-if="invanStore"
              icon
              @click="
                deleteStore();
                dialog = false;
              "
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
            <v-spacer />
            <v-btn text v-on:click="dialog = false">{{ $t("cancel") }}</v-btn>
            <v-btn
              text
              color="success"
              :loading="loading_crud"
              v-on:click="saving"
              :disabled="saveDisabled"
              >{{ $t("save") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-btn
        v-if="
          (!invPurchase && selected.length !== 0 && !InventorySuplier) ||
          (InventorySuplier && access.is_boss && selected.length !== 0)
        "
        text
        color="error"
        v-on:click="removing"
      >
        <v-icon>mdi-delete</v-icon>
        {{ $t("delete") }}
      </v-btn>
      <v-dialog v-model="dialog_import" v-if="upload" width="500">
        <template #activator="{ on }">
          <v-btn class="mx-1" v-on="on" text>{{ $t("import") }}</v-btn>
        </template>
        <v-card>
          <v-card-title>{{ $t("import") }} {{ name }}</v-card-title>
          <v-card-text>
            <a href="http://purch.invan.uz/static/customers.csv"
              >Download template file</a
            >
            and fill in with the customers information.
          </v-card-text>
          <v-card-text>
            <v-file-input
              v-model="file"
              accept=".csv"
              label="Select File..."
              show-size
              filled
            ></v-file-input>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn text v-on:click="dialog_import = false">{{
              $t(`cancel`)
            }}</v-btn>
            <v-btn text v-on:click="uploading">{{ $t(`upload`) }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-btn
        v-if="itemsView && !itemsMark"
        class="mx-1"
        text
        @click="importClicked"
        >{{ $t(`import`) }}</v-btn
      >
      <v-btn
        class="mx-1"
        v-if="download && !itemsMark"
        v-on:click="downloading"
        text
        >{{ $t(`export`) }}</v-btn
      >
      <template v-if="$slots.top && search_text == false">
        <slot name="top" />
      </template>

      <v-spacer />
      <v-flex
        class="ma-0 pa-0"
        :class="search_text ? 'md6' : 'md1'"
        v-if="showSearch"
      >
        <v-row class="ma-0 pa-0">
          <v-spacer></v-spacer>
          <v-btn icon @click="searchActivate(true)">
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
          <v-text-field
            v-model="search"
            ref="search_field"
            v-if="search_text"
            autofocus
            class="mt-3 pa-0"
            append-icon="mdi-close"
            @click:append="searchAppend()"
            @change="getData()"
            label="Search"
          />
        </v-row>
      </v-flex>
      <slot name="search" />
      <!-- <v-spacer /> -->
      <v-menu v-if="Itemss" offset-y v-bind:close-on-content-click="false">
        <template #activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>mdi-table-column</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-list dense>
            <v-list-item v-for="(header, index) in headers" v-bind:key="index">
              <v-list-item-action>
                <v-checkbox
                  hide-details
                  v-model="header.available"
                  v-bind:disabled="header.disabled"
                />
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ header.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>
    </v-toolbar>
    <v-toolbar v-if="supplierTransaction || TotalHours" flat>
      <slot name="search" />
    </v-toolbar>

    <v-data-table
      v-model="selected"
      hide-default-footer
      v-bind:headers="computed_headers"
      v-bind:items="data"
      disable-sort
      :loading="loading_items_table_data"
      v-bind:show-select="!noDelete"
      :single-select="singleSelect"
      v-on:click:row="typing"
      item-key="_id"
      class="pa-0"
      :mobile-breakpoint="0"
      :items-per-page="200000"
      @current-items="calculateTotal"
      @toggle-select-all="selectAllToggle"
      :no-data-text="noDataText"
    >
      <template #[`body.append`]>
        <slot name="footear" />
      </template>
      <template
        v-if="itemsView && has_variant"
        #[`header.data-table-select`]="{ on, props }"
      >
        <v-checkbox
          class="ml-8 pl-4"
          color="#707070"
          v-bind="props"
          v-on="on"
          @change="mainSelectClicked"
          :ripple="false"
        />
      </template>

      <template
        v-if="invPurchase"
        #[`item.data-table-select`]="{ item, isSelected }"
      >
        <v-simple-checkbox
          :value="isSelected"
          :readonly="item.state != 'pending'"
          :disabled="item.state != 'pending'"
          @change="addSelected(item)"
        />
      </template>
      <template
        v-else-if="itemsView && has_variant"
        #[`item.data-table-select`]="{ item }"
      >
        <v-row class="ma-0 pa-0 mt-3" flat color="transparent">
          <div class="ma-0 pa-0 mr-3">
            <v-btn
              v-if="item.has_variants"
              class="ma-0 pa-0"
              icon
              @click="openVariants(item, !item.open_variants)"
            >
              <v-icon v-if="!item.open_variants">mdi-chevron-down</v-icon>
              <v-icon v-else>mdi-chevron-up</v-icon>
            </v-btn>
            <v-btn v-else icon disabled></v-btn>
          </div>
          <v-checkbox
            v-if="item.item_type == 'item'"
            class="ma-0 pa-0 mt-1"
            color="#707070"
            @change="addSelected(item)"
            :value="selected.includes(item)"
          />
        </v-row>
      </template>
      <template v-if="InventoryPurchaseEmployee" #[`item.status`]="{ item }">
        <v-chip small :color="getColor(item.state)" dark>
          {{ item.status }}
        </v-chip>
      </template>
      <template v-if="itemsView" #[`item.representation`]="{ item }">
        <div style="width: 30px; height: 30px" v-if="item.representation">
          <v-img
            @click="openDialog(item.representation)"
            :src="
              item.representation.startsWith('#')
                ? `${noImage}`
                : item.representation
            "
          />
        </div>
      </template>
      <template v-if="itemsView" #[`item.barcode`]="{ item }">
        <div style="width: 250px">
          {{
            item.barcode.toString().length > 60
              ? item.barcode.toString().substring(0, 60).concat("...")
              : item.barcode.toString()
          }}
        </div>
      </template>
      <template v-if="itemsView" #[`item.name`]="{ item }">
        <div v-if="item.item_type == 'item'" @click="typing(item, false)">
          <v-list-item-content>
            <!-- <v-list-item-title> -->
            <p style="width: 300px">
              {{ item.name }}
            </p>
            <!-- </v-list-item-title> -->
            <v-list-item-subtitle class="caption grey--text" v-if="itemsMark">
              SKU {{ item.sku }}
            </v-list-item-subtitle>
            <v-list-item-subtitle
              v-if="
                itemsMark &&
                item.barcode instanceof Array &&
                item.barcode.length > 0
              "
              class="caption grey--text"
            >
              <span v-for="(barcode, ind) in item.barcode" :key="ind">
                {{ barcode + ", " }}
              </span>
            </v-list-item-subtitle>
          </v-list-item-content>
        </div>
        <div v-else @click="openVariantDialog(item)">{{ item.name }}</div>
      </template>
      <template v-if="itemsView" #[`item.category_name`]="{ item }">
        <v-menu
          :value="categoryMenu && item_id == item._id"
          offset-y
          v-bind:close-on-content-click="true"
        >
          <template #activator="{ on }">
            <v-text-field
              v-if="item.item_type == 'item'"
              class="ma-0 pa-0 mt-3 text-field"
              readonly
              v-on="on"
              @click="activateCurrent(item)"
              v-model="item.category_name"
            />
          </template>
          <v-card max-height="250" width="250" class="overflow-y-auto">
            <v-treeview
              dense
              activatable
              item-key="_id"
              v-bind:items="all_categories"
              :load-children="fetchCategories"
              v-on:update:active="activated"
            ></v-treeview>
          </v-card>
        </v-menu>
      </template>
      <template v-if="itemsView" #[`item.mxik`]="{ item }">
        <v-menu
          v-if="oneService && !item.has_variants"
          :value="item.show_edit_mxik"
          offset-y
          :close-on-content-click="false"
          class="pa-0"
        >
          <template #activator="{ on }">
            <v-text-field
              @click="showEditMxik(item, !item.show_edit_mxik), on"
              :value="item.mxik"
              class="right-input ma-0 pa-0 mt-3"
              readonly
            ></v-text-field>
          </template>
          <v-toolbar
            v-if="
              (access.item_edit && Itemss) ||
              (itemsMark && access.item_mark_edit)
            "
            class="ma-0 pa-0"
            dense
          >
            <v-btn icon @click="showEditMxik(item, false)">
              <v-icon color="red">mdi-close</v-icon>
            </v-btn>
            <v-divider vertical></v-divider>
            <v-btn icon @click="editItemMxik(item)">
              <v-icon color="primary">mdi-check</v-icon>
            </v-btn>
            <v-divider vertical></v-divider>
            <v-text-field
              v-model="item_mxik"
              type="number"
              style="width: 200px"
              class="ma-0 pa-0 mt-6 mb-6"
              @focus="$event.target.select()"
              :autofocus="item.show_edit_mxik && oneService"
              counter
              maxlength="17"
            ></v-text-field>
          </v-toolbar>
        </v-menu>
        <div class="ma-0 pa-0" v-else>
          {{ item.mxik }}
        </div>
      </template>
      <template v-if="itemsView" #[`item.nds_value`]="{ item }">
        <v-menu
          v-if="oneService && !item.has_variants"
          :value="item.show_edit_nds_value"
          offset-y
          :close-on-content-click="false"
          class="pa-0"
        >
          <template #activator="{ on }">
            <v-text-field
              @click="showEditNDS(item, !item.show_edit_nds_value), on"
              :value="item.nds_value"
              class="right-input ma-0 pa-0 mt-3"
              readonly
            ></v-text-field>
          </template>
          <v-toolbar
            v-if="
              (access.item_edit && Itemss) ||
              (itemsMark && access.item_mark_edit)
            "
            class="ma-0 pa-0"
            dense
          >
            <v-btn icon @click="showEditNDS(item, false)">
              <v-icon color="red">mdi-close</v-icon>
            </v-btn>
            <v-divider vertical></v-divider>
            <v-btn icon @click="editItemNDS(item)">
              <v-icon color="primary">mdi-check</v-icon>
            </v-btn>
            <v-divider vertical></v-divider>
            <v-text-field
              v-model="item_nds_value"
              type="number"
              style="width: 50px"
              class="ma-0 pa-0 mt-6 mb-6"
              @focus="$event.target.select()"
              :autofocus="item.show_edit_nds_value && oneService"
            ></v-text-field>
          </v-toolbar>
        </v-menu>
        <div class="ma-0 pa-0" v-else>
          {{ item.nds_value }}
        </div>
      </template>
      <template v-if="itemsView" #[`item.price`]="{ item }">
        <v-menu
          v-if="oneService"
          :value="item.show_edit_price"
          offset-y
          :close-on-content-click="false"
          class="pa-0"
        >
          <template #activator="{ on }">
            <v-text-field
              v-if="!item.has_variants"
              @click="showEditPrice(item, !item.show_edit_price), on"
              :value="item.price ? item.price.toLocaleString() : item.price"
              class="right-input ma-0 pa-0 mt-3"
              readonly
              :suffix="item.price_currency == 'usd' ? '$' : ''"
            ></v-text-field>
          </template>
          <v-toolbar v-if="access.item_edit" class="ma-0 pa-0" dense>
            <v-btn icon @click="showEditPrice(item, false)">
              <v-icon color="red">mdi-close</v-icon>
            </v-btn>
            <v-divider vertical></v-divider>
            <v-btn icon @click="editItemPrice(item)">
              <v-icon color="primary">mdi-check</v-icon>
            </v-btn>
            <v-divider vertical></v-divider>
            <vuetify-money
              v-model="item_price"
              style="width: 100px"
              class="ma-0 pa-0 mt-5"
              v-bind:options="
                item.price_currency == 'usd' ? moneyOptionsUSD : moneyOptions
              "
              :autofocus="item.show_edit_price && oneService"
            />
          </v-toolbar>
        </v-menu>
        <div class="ma-0 pa-0" v-else-if="!item.has_variants && item.price">
          {{
            item.price_currency == "usd"
              ? Math.round(item.price * 100) / 100
              : Math.round(item.price).toLocaleString()
          }}{{ item.price_currency == "usd" ? " $" : "" }}
        </div>
      </template>
      <template v-if="itemsView || itemsMark" #[`item.cost`]="{ item }">
        <div v-if="itemsMark">
          {{ item.cost ? item.cost.toLocaleString() : item.cost }}
        </div>
        <div
          style="width: 100px"
          class="ma-0 pa-0"
          v-else-if="
            item.cost &&
            (item.is_track_stock ||
              (item.is_composite_item && item.use_production)) &&
            !item.has_variants
          "
        >
          {{
            item.cost_currency == "usd"
              ? item.cost
              : Math.round(item.cost).toLocaleString()
          }}{{ item.cost_currency == "usd" ? " $" : "" }}
        </div>
        <v-menu
          v-else-if="!item.has_variants"
          :value="item.show_edit_cost"
          offset-y
          :close-on-content-click="false"
          class="pa-0"
        >
          <template #activator="{ on }">
            <v-text-field
              v-if="!item.has_variants"
              @click="showEditCost(item, !item.show_edit_cost), on"
              :value="item.cost ? item.cost.toLocaleString() : item.cost"
              class="right-input ma-0 pa-0 mt-3"
              readonly
              :suffix="item.cost_currency == 'usd' ? '$' : ''"
            ></v-text-field>
          </template>
          <v-toolbar v-if="access.item_edit" class="ma-0 pa-0" dense>
            <v-btn icon @click="showEditCost(item, false)">
              <v-icon color="red">mdi-close</v-icon>
            </v-btn>
            <v-divider vertical></v-divider>
            <v-btn icon @click="editItemCost(item)">
              <v-icon color="primary">mdi-check</v-icon>
            </v-btn>
            <v-divider vertical></v-divider>
            <vuetify-money
              v-model="item_cost"
              style="width: 100px"
              class="ma-0 pa-0 mt-5"
              v-bind:options="
                item.cost_currency == 'usd' ? moneyOptionsUSD : moneyOptions
              "
              :autofocus="item.show_edit_cost"
            />
          </v-toolbar>
        </v-menu>
      </template>
      <template v-if="itemsView" #[`item.in_stock`]="{ item }">
        <v-menu
          v-if="
            oneService && typeof item.in_stock == typeof 5 && !item.has_variants
          "
          :value="item.show_edit_in_stock"
          offset-y
          :close-on-content-click="false"
          class="pa-0"
        >
          <template #activator="{ on }">
            <v-text-field
              @click="showEditInStock(item, !item.show_edit_in_stock), on"
              :value="item.in_stock"
              class="right-input ma-0 pa-0 mt-3"
              readonly
            ></v-text-field>
          </template>
          <v-toolbar
            v-if="
              (access.item_edit && Itemss) ||
              (itemsMark && access.item_mark_edit)
            "
            class="ma-0 pa-0"
            dense
          >
            <v-btn icon @click="showEditInStock(item, false)">
              <v-icon color="red">mdi-close</v-icon>
            </v-btn>
            <v-divider vertical></v-divider>
            <v-btn icon @click="editItemInStock(item)">
              <v-icon color="primary">mdi-check</v-icon>
            </v-btn>
            <v-divider vertical></v-divider>
            <v-text-field
              v-model="item_in_stock"
              type="number"
              style="width: 100px"
              class="ma-0 pa-0 mt-5"
              @focus="$event.target.select()"
              :autofocus="item.show_edit_in_stock && oneService"
            ></v-text-field>
          </v-toolbar>
        </v-menu>
        <div class="ma-0 pa-0" v-else>
          {{
            item.is_track_stock == false ||
            (item.is_composite_item && item.use_production == false)
              ? "—"
              : item.in_stock
          }}
        </div>
      </template>
      <template v-if="itemsView" #[`item.reminder`]="{ item }">
        <v-menu
          v-if="
            oneService && typeof item.reminder == typeof 5 && !item.has_variants
          "
          :value="item.show_edit_reminder"
          offset-y
          :close-on-content-click="false"
          class="pa-0"
        >
          <template #activator="{ on }">
            <v-text-field
              @click="showEditReminder(item, !item.show_edit_reminder), on"
              :value="item.reminder"
              class="right-input ma-0 pa-0 mt-3"
              readonly
            ></v-text-field>
          </template>
          <v-toolbar class="ma-0 pa-0" dense>
            <v-btn icon @click="showEditReminder(item, false)">
              <v-icon color="red">mdi-close</v-icon>
            </v-btn>
            <v-divider vertical></v-divider>
            <v-btn icon @click="editItemReminder(item)">
              <v-icon color="primary">mdi-check</v-icon>
            </v-btn>
            <v-divider vertical></v-divider>
            <v-text-field
              v-model="item_reminder"
              type="number"
              style="width: 100px"
              class="ma-0 pa-0 mt-5"
              @focus="$event.target.select()"
              :autofocus="item.show_edit_reminder && oneService"
            ></v-text-field>
          </v-toolbar>
        </v-menu>
        <div class="ma-0 pa-0" v-else>
          {{
            item.is_track_stock == false ||
            (item.is_composite_item && item.use_production == false)
              ? "—"
              : item.reminder
          }}
        </div>
      </template>

      <template v-if="itemsView" #[`item.margin`]="{ item }">
        <div v-if="!item.has_variants">
          {{
            item.price && item.cost
              ? (((item.price - item.cost) / item.cost) * 100).toFixed(2)
              : 0
          }}%
          <!-- {{(item.price && +item.price.replace(',', '') && item.cost && +item.cost.replace(',', ''))?(Math.round((+item.price.replace(',', '')-(+item.cost.replace(',', '')))/+item.cost.replace(',', '')*10000)/100):'0'}} % -->
        </div>
      </template>
      <!-- itemsMark -->
      <!-- price1 -->
      <template
        v-if="itemsMark && access.item_mark_edit"
        #[`item.price1`]="{ item }"
      >
        <v-menu
          v-if="oneService"
          :value="item.show_edit_price1"
          offset-y
          :close-on-content-click="false"
          class="pa-0"
        >
          <template #activator="{ on }">
            <v-text-field
              v-if="!item.has_variants"
              @click="showEditPrice1(item, !item.show_edit_price1), on"
              :value="item.price1 ? item.price1.toLocaleString() : item.price1"
              class="right-input ma-0 pa-0 mt-3"
              readonly
            ></v-text-field>
          </template>
          <v-toolbar class="ma-0 pa-0" dense>
            <v-btn icon @click="showEditPrice1(item, false)">
              <v-icon color="red">mdi-close</v-icon>
            </v-btn>
            <v-divider vertical></v-divider>
            <v-btn icon @click="editItemPrice1(item)">
              <v-icon color="primary">mdi-check</v-icon>
            </v-btn>
            <v-divider vertical></v-divider>
            <vuetify-money
              v-model="item_price1"
              style="width: 100px"
              class="ma-0 pa-0 mt-5"
              :autofocus="item.show_edit_price1 && oneService"
              v-bind:options="moneyOptions"
            />
          </v-toolbar>
        </v-menu>
        <div class="ma-0 pa-0" v-else-if="!item.has_variants">
          {{ item.price1 ? item.price1.toLocaleString() : item.price1 }}
        </div>
      </template>
      <!-- price2 -->
      <template
        v-if="itemsMark && access.item_mark_edit"
        #[`item.price2`]="{ item }"
      >
        <v-menu
          v-if="oneService"
          :value="item.show_edit_price2"
          offset-y
          :close-on-content-click="false"
          class="pa-0"
        >
          <template #activator="{ on }">
            <v-text-field
              v-if="!item.has_variants"
              @click="showEditPrice2(item, !item.show_edit_price2), on"
              :value="item.price2 ? item.price2.toLocaleString() : item.price2"
              class="right-input ma-0 pa-0 mt-3"
              readonly
            ></v-text-field>
          </template>
          <v-toolbar class="ma-0 pa-0" dense>
            <v-btn icon @click="showEditPrice2(item, false)">
              <v-icon color="red">mdi-close</v-icon>
            </v-btn>
            <v-divider vertical></v-divider>
            <v-btn icon @click="editItemPrice2(item)">
              <v-icon color="primary">mdi-check</v-icon>
            </v-btn>
            <v-divider vertical></v-divider>
            <vuetify-money
              v-model="item_price2"
              style="width: 100px"
              class="ma-0 pa-0 mt-5"
              :autofocus="item.show_edit_price2 && oneService"
              v-bind:options="moneyOptions"
            />
          </v-toolbar>
        </v-menu>
        <div class="ma-0 pa-0" v-else-if="!item.has_variants">
          {{ item.price2 }}
        </div>
      </template>
      <!-- price3 -->
      <template
        v-if="itemsMark && access.item_mark_edit"
        #[`item.price3`]="{ item }"
      >
        <v-menu
          v-if="oneService"
          :value="item.show_edit_price3"
          offset-y
          :close-on-content-click="false"
          class="pa-0"
        >
          <template #activator="{ on }">
            <v-text-field
              v-if="!item.has_variants"
              @click="showEditPrice3(item, !item.show_edit_price3), on"
              :value="item.price3 ? item.price3.toLocaleString() : item.price3"
              class="right-input ma-0 pa-0 mt-3"
              readonly
            ></v-text-field>
          </template>
          <v-toolbar class="ma-0 pa-0" dense>
            <v-btn icon @click="showEditPrice3(item, false)">
              <v-icon color="red">mdi-close</v-icon>
            </v-btn>
            <v-divider vertical></v-divider>
            <v-btn icon @click="editItemPrice3(item)">
              <v-icon color="primary">mdi-check</v-icon>
            </v-btn>
            <v-divider vertical></v-divider>
            <vuetify-money
              v-model="item_price3"
              style="width: 100px"
              class="ma-0 pa-0 mt-5"
              :autofocus="item.show_edit_price3 && oneService"
              v-bind:options="moneyOptions"
            />
          </v-toolbar>
        </v-menu>
        <div class="ma-0 pa-0" v-else-if="!item.has_variants">
          {{ item.price3 }}
        </div>
      </template>
      <!-- from1 -->
      <template
        v-if="itemsMark && access.item_mark_edit"
        #[`item.from1`]="{ item }"
      >
        <v-menu
          v-if="oneService"
          :value="item.show_edit_from1"
          offset-y
          :close-on-content-click="false"
          class="pa-0"
        >
          <template #activator="{ on }">
            <v-text-field
              v-if="!item.has_variants"
              @click="showEditFrom1(item, !item.show_edit_from1), on"
              :value="item.from1"
              class="ma-0 pa-0 mt-3"
              readonly
            ></v-text-field>
          </template>
          <v-toolbar class="ma-0 pa-0" dense>
            <v-btn icon @click="showEditFrom1(item, false)">
              <v-icon color="red">mdi-close</v-icon>
            </v-btn>
            <v-divider vertical></v-divider>
            <v-btn icon @click="editItemFrom1(item)">
              <v-icon color="primary">mdi-check</v-icon>
            </v-btn>
            <v-divider vertical></v-divider>
            <v-text-field
              v-model="item_from1"
              style="width: 100px"
              class="ma-0 pa-0 mt-5"
              :autofocus="item.show_edit_from1 && oneService"
              @focus="$event.target.select()"
            />
          </v-toolbar>
        </v-menu>
        <div class="ma-0 pa-0" v-else-if="!item.has_variants">
          {{ item.from1 }}
        </div>
      </template>
      <!-- from2 -->
      <template
        v-if="itemsMark && access.item_mark_edit"
        #[`item.from2`]="{ item }"
      >
        <v-menu
          v-if="oneService"
          :value="item.show_edit_from2"
          offset-y
          :close-on-content-click="false"
          class="pa-0"
        >
          <template #activator="{ on }">
            <v-text-field
              v-if="!item.has_variants"
              @click="showEditFrom2(item, !item.show_edit_from2), on"
              :value="item.from2"
              class="ma-0 pa-0 mt-3"
              readonly
            ></v-text-field>
          </template>
          <v-toolbar class="ma-0 pa-0" dense>
            <v-btn icon @click="showEditFrom2(item, false)">
              <v-icon color="red">mdi-close</v-icon>
            </v-btn>
            <v-divider vertical></v-divider>
            <v-btn icon @click="editItemFrom2(item)">
              <v-icon color="primary">mdi-check</v-icon>
            </v-btn>
            <v-divider vertical></v-divider>
            <v-text-field
              v-model="item_from2"
              style="width: 100px"
              class="ma-0 pa-0 mt-5"
              :autofocus="item.show_edit_from2 && oneService"
              @focus="$event.target.select()"
            />
          </v-toolbar>
        </v-menu>
        <div class="ma-0 pa-0" v-else-if="!item.has_variants">
          {{ item.from2 }}
        </div>
      </template>
      <!-- from3 -->
      <template
        v-if="itemsMark && access.item_mark_edit"
        #[`item.from3`]="{ item }"
      >
        <v-menu
          v-if="oneService"
          :value="item.show_edit_from3"
          offset-y
          :close-on-content-click="false"
          class="pa-0"
        >
          <template #activator="{ on }">
            <v-text-field
              v-if="!item.has_variants"
              @click="showEditFrom3(item, !item.show_edit_from3), on"
              :value="item.from3"
              class="ma-0 pa-0 mt-3"
              readonly
            ></v-text-field>
          </template>
          <v-toolbar class="ma-0 pa-0" dense>
            <v-btn icon @click="showEditFrom3(item, false)">
              <v-icon color="red">mdi-close</v-icon>
            </v-btn>
            <v-divider vertical></v-divider>
            <v-btn icon @click="editItemFrom3(item)">
              <v-icon color="primary">mdi-check</v-icon>
            </v-btn>
            <v-divider vertical></v-divider>
            <v-text-field
              v-model="item_from3"
              style="width: 100px"
              class="ma-0 pa-0 mt-5"
              :autofocus="item.show_edit_from3 && oneService"
              @focus="$event.target.select()"
            />
          </v-toolbar>
        </v-menu>
        <div class="ma-0 pa-0" v-else-if="!item.has_variants">
          {{ item.from3 }}
        </div>
      </template>

      <template v-if="itemsMark" #[`item.margin1`]="{ item }">
        <div v-if="!item.has_variants">
          {{
            item.price1 && item.cost
              ? Math.round(
                  (((item.price1 - item.cost) * 1.0) / item.cost) * 10000
                ) / 100
              : "0"
          }}%
        </div>
      </template>
      <template v-if="itemsMark" #[`item.margin2`]="{ item }">
        <div v-if="!item.has_variants">
          {{
            item.price2 && item.cost
              ? Math.round(
                  (((item.price2 - item.cost) * 1.0) / item.cost) * 10000
                ) / 100
              : "0"
          }}%
        </div>
      </template>
      <template v-if="itemsMark" #[`item.margin3`]="{ item }">
        <div v-if="!item.has_variants">
          {{
            item.price1 && item.cost
              ? Math.round(
                  (((item.price3 - item.cost) * 1.0) / item.cost) * 10000
                ) / 100
              : "0"
          }}%
        </div>
      </template>

      <template v-if="itemsView" #[`item.stock_status`]="{ item }">
        <p
          v-if="item.stock_status && item.stock_status.low_stock > 0"
          class="pa-0 ma-0 font-weight-bold"
          style="color: #fb8000"
        >
          <!-- Low stock -->
          ({{ item.stock_status.low_stock }})
        </p>
        <p
          v-if="item.stock_status && item.stock_status.out_of_stock > 0"
          class="pa-0 ma-0 font-weight-bold"
          style="color: #e01212"
        >
          <!-- Out of stock -->
          ({{ item.stock_status.out_of_stock }})
        </p>
      </template>

      <!-- <template v-if="itemsView" #[`item.hyper_link`]="{ item }">
        <v-btn
          v-if="item.in_stock < 0"
          icon
          color="primary"
          @click="orderHyperLink(item)"
        >
          <v-icon> mdi-link-variant </v-icon>
        </v-btn>
      </template> -->

      <!-- inventory purchase -->
      <template #[`item.purchase_order_date`]="{ item }">{{
        date_ddmmyy(item.purchase_order_date)
      }}</template>
      <template #[`item.received`]="{ item }">
        <v-progress-linear
          :color="
            item.state == 'partially' ? 'rgb(140,199,72)' : 'rgba(0,0,0,0.26)'
          "
          background-color="white"
          height="10"
          style="border: 1px solid rgba(0, 0, 0, 0.26); margin-top: 10px"
          v-bind:value="(item.received / item.total_count) * 100"
          striped
        />
      </template>
      <template
        v-if="InventoryPurchaseEmployee"
        #[`item.items_count`]="{ item }"
      >
        <div style="width: 100px">
          <v-progress-linear
            :color="
              item.items_count == item.accept_items_count
                ? 'rgb(140,199,72)'
                : 'rgba(0,0,0,0.26)'
            "
            background-color="white"
            height="10"
            style="border: 1px solid rgba(0, 0, 0, 0.26); margin-top: 10px"
            v-bind:value="(item.accept_items_count / item.items_count) * 100"
            striped
          />
          <v-list-item-action-text>
            {{ $t("accept") }} {{ item.accept_items_count }} of
            {{ item.items_count }}
          </v-list-item-action-text>
        </div>
      </template>
      <template #[`item.expected_on`]="{ item }">
        <p
          class="ma-0 pa-0"
          :class="item.expected_on <= new Date().getTime() ? 'red--text' : ''"
        >
          {{ date_ddmmyy(item.expected_on) }}
        </p>
      </template>
      <template #[`item.type`]="{ item }">{{ $t(item.type) }}</template>
      <template #[`item.total`]="{ item }"
        >{{ item.total ? item.total.toLocaleString() : item.total
        }}{{ item.total_currency == "usd" ? " $" : "" }}</template
      >
      <template #[`item.last_pricing_date`]="{ item }">
        {{
          item.pricing_status && item.last_pricing_date
            ? date_ddmmyy_hhmm(item.last_pricing_date)
            : ""
        }}
      </template>
      <template #[`item.start_time`]="{ item }">
        {{ date_ddmmyy_hhmm(item.start_time) }}
      </template>
      <template #[`item.end_time`]="{ item }">
        {{ date_ddmmyy_hhmm(item.end_time) }}
      </template>
      <template #[`item.value`]="{ item }"> {{ item.value }}% </template>
      <template v-if="ClientStatus" #[`item.percentage`]="{ item }">
        {{ item.percentage }}%
      </template>
      <!-- -->
      <!-- supplierTransaction -->
      <template v-if="supplierTransaction" #[`item.balance`]="{ item }">{{
        item && item.balance ? item.balance.toLocaleString() : item.balance
      }}</template>
      <!-- Fees -->
      <template v-if="Fees" #[`item.amount_type`]="{ item }">{{
        $t(item.amount_type)
      }}</template>
      <template
        v-if="Fees || InventoryPurchaseEmployee"
        #[`item.date`]="{ item }"
        >{{ date_ddmmyy_hhmm(item.date) }}</template
      >
      <template v-if="Fees" #[`item.currency_amount`]="{ item }"
        >{{
          item.currency_amount
            ? item.currency_amount.toLocaleString()
            : item.amount
            ? item.amount.toLocaleString()
            : item.amount
        }}{{ item.currency == "usd" ? " $" : "" }}</template
      >
      <template #[`item.potential`]="{ item }">
        <div v-if="!Number.isInteger(item.potential)">
          <div v-if="item.potential">
            {{ Number(item.potential).toFixed(2) }}
          </div>
          <div v-else></div>
        </div>
        <div v-else>{{ item.potential }}</div>
      </template>
      <template #[`item.inventory`]="{ item }">
        <div v-if="!Number.isInteger(item.inventory)">
          <div v-if="item.inventory">
            {{ Number(item.inventory).toFixed(2) }}
          </div>
          <div v-else></div>
        </div>
        <div v-else>{{ item.inventory }}</div>
      </template>
      <template #top>
        <slot name="tabletop"></slot>
      </template>
    </v-data-table>
    <template v-if="value && numPages">
      <v-layout row px-4 class="mt-3">
        <v-flex md10>
          <v-pagination
            v-model="pagination_value"
            v-bind:length="numPages"
            total-visible="7"
            @input="paginationChange"
            @next="paginationChange"
            @previous="paginationChange"
            class="elevation-0"
            color="success"
          ></v-pagination>
        </v-flex>
        <v-flex md2 v-if="itemsView">
          <v-select
            style="width: 60px"
            class="ma-0 pa-0"
            v-model="limit_value"
            :items="limits"
          ></v-select>
        </v-flex>
      </v-layout>
    </template>
    <v-dialog v-model="imageDialog" :width="400" @keydown.esc="cancel">
      <v-card>
        <v-img :src="imgurl" />
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
import Categories from "../../mixins/items/categories";
import NoImage from "../../../public/img/no-image.svg";
export default {
  name: "v-crud-card",
  mixins: [Categories, NoImage],
  props: {
    create: { type: Boolean, default: true },
    value: { type: Number, default: null },
    limit: { type: [Number, String], default: 10 },
    numPages: { type: Number, default: null },
    loading_items_table_data: { type: Boolean, default: false },
    name: String,
    upload: String,
    download: String,
    itemsView: { type: Boolean, default: false },
    itemsMark: { type: Boolean, default: false },
    Buttons: { type: Boolean, default: false },
    has_variant: { type: Boolean, default: false },
    oneService: { type: Boolean, default: false },
    importItem: { type: Function, default: () => {} },
    headers: { type: Array, default: () => [] },
    data: { type: Array, default: () => [] },
    // all_categories: { type: Array, default: () => [] },
    // fetchCategories: { type: Function, default: () => {} },
    dialogWidth: { type: Number, default: 500 },
    to: String,
    row: Function,
    save: Function,
    remove: Function,
    calculateTotal: {
      type: Function,
      default: () => {},
    },
    noDelete: Boolean,
    dialogCancel: {
      type: Function,
      default: () => {},
    },
    ClientStatus: Boolean,
    PromotionsItemsDiscount: Boolean,
    InventoryPurchaseEmployee: Boolean,
    Itemss: Boolean,
    ItemModifier: Boolean,
    ItemDiscount: Boolean,
    InventoryPurchase: Boolean,
    InventoryTransfer: Boolean,
    InventoryStock: Boolean,
    InventoryCount: Boolean,
    InventoryProduction: Boolean,
    InventorySuplier: Boolean,
    Fees: Boolean,
    EmployeesTimeCard: Boolean,
    EmployeesAccess: Boolean,
    Employees: Boolean,
    Customers: Boolean,
    SettingsDevice: Boolean,
    SettingsOptions: Boolean,
    SettingsButton: Boolean,
    SettingsTaxe: Boolean,
    view: Boolean,
    add: Boolean,
    invPurchaseMark: Boolean,
    supplierTransaction: Boolean,
    toSupplier: String,
    TotalHours: Boolean,
    add_button_name: String,
    saveDisabled: {
      type: Boolean,
      default: false,
    },
    showSearch: {
      type: Boolean,
      default: false,
    },
    search_text: {
      type: Boolean,
      default: false,
    },
    searchActivate: {
      type: Function,
      default: () => {},
    },
    getData: {
      type: Function,
      default: () => {},
    },
    setText: {
      type: Function,
      default: () => {},
    },
    invanStore: {
      type: Boolean,
      default: false,
    },
    deleteStore: {
      type: Function,
      default: () => {},
    },
    orderHyperLink: {
      type: Function,
      default: () => {},
    },
    invPurchase: Boolean,
    noDataText: {
      type: String,
      default: "No data available",
    },
  },
  data: () => ({
    categoryMenu: false,
    pagination_value: 1,
    limit_value: 10,
    limits: [10, 20, 50, 100],
    selected: [],
    dialog: false,
    dialog_import: false,
    singleSelect: false,
    file: null,
    edit_cost_menu: false,
    item_cost: "",
    item_price: "",
    item_price1: "",
    item_price2: "",
    item_price3: "",
    item_from1: "",
    item_from2: "",
    item_from3: "",
    item_in_stock: "",
    item_mxik: "",
    item_nds_value: "",
    item_reminder: "",
    item_id: "",
    map: {},
    search: "",
    loading_crud: false,
    item_count_by_type: 0,
    imageDialog: false,
    imgurl: "",
    noImage: NoImage,
  }),
  watch: {
    value() {
      this.pagination_value = this.value;
    },
    limit() {
      this.limit_value = this.limit;
    },
    limit_value() {
      this.$emit("change-limit", this.limit_value);
    },
    search() {
      this.setText(this.search);
    },
    item_reminder() {
      if (this.item_count_by_type - 1 < this.item_reminder) {
        this.item_reminder = this.item_count_by_type - 1;
      }
    },
  },
  methods: {
    cancel() {
      this.imageDialog = false;
    },
    openDialog(imageSrc) {
      this.imgurl = imageSrc;
      this.imageDialog = true;
    },
    selectAllToggle(props) {
      const self = this;
      if (this.selected.length == 0) {
        props.items.forEach((item) => {
          if (item.state == "pending") {
            self.selected.push(item);
          }
        });
      } else {
        this.selected = [];
      }
    },
    importClicked() {
      // this.$emit("importItem");
      this.importItem();
    },
    searchAppend() {
      this.searchActivate(false);
      this.setText("");
      this.getData();
    },
    paginationChange() {
      this.$emit("change-pagination", this.pagination_value);
    },
    downloading() {
      this.$communicator.download(this.download);
    },
    async uploading() {
      await this.$communicator.file(this.upload, { file: this.file });
    },
    addSelected(item) {
      const selected = [];
      if (this.selected.includes(item)) {
        for (const sel of this.selected) {
          if (item != sel) {
            selected.push(sel);
          }
        }
        this.selected = selected;
      } else {
        this.selected.push(item);
      }
    },
    mainSelectClicked() {
      this.selected.length != this.data.length
        ? (this.selected = this.data)
        : (this.selected = []);
    },
    showEditCost(item, state = false) {
      if (typeof item.cost == typeof "salom") {
        // this.item_cost = item.cost ? item.cost.replace(",", "") : 0;
        this.item_cost = item.cost;
      }
      this.$emit("show-edit-cost", item._id, state);
    },
    editItemCost(item) {
      this.$emit("edit-item-cost", item._id, this.item_cost);
    },
    showEditPrice(item, state = false) {
      // this.item_price = item.price ? item.price.replace(",", "") : 0;
      this.item_price = item.price;
      this.$emit("show-edit-price", item._id, state);
    },
    editItemPrice(item) {
      this.$emit("edit-item-price", item._id, this.item_price);
    },
    showEditPrice1(item, state = false) {
      this.item_price1 = item.price1;
      this.$emit("show-edit-price1", item._id, state);
    },
    editItemPrice1(item) {
      this.$emit("edit-item-price1", item._id, this.item_price1);
    },
    showEditPrice2(item, state = false) {
      this.item_price2 = item.price2;
      this.$emit("show-edit-price2", item._id, state);
    },
    editItemPrice2(item) {
      this.$emit("edit-item-price2", item._id, this.item_price2);
    },
    showEditPrice3(item, state = false) {
      this.item_price3 = item.price3;
      this.$emit("show-edit-price3", item._id, state);
    },
    editItemPrice3(item) {
      this.$emit("edit-item-price3", item._id, this.item_price3);
    },
    showEditFrom1(item, state = false) {
      this.item_from1 = item.from1;
      this.$emit("show-edit-from1", item._id, state);
    },
    editItemFrom1(item) {
      this.$emit("edit-item-from1", item._id, this.item_from1);
    },
    showEditFrom2(item, state = false) {
      this.item_from2 = item.from2;
      this.$emit("show-edit-from2", item._id, state);
    },
    editItemFrom2(item) {
      this.$emit("edit-item-from2", item._id, this.item_from2);
    },
    showEditFrom3(item, state = false) {
      this.item_from3 = item.from3;
      this.$emit("show-edit-from3", item._id, state);
    },
    editItemFrom3(item) {
      this.$emit("edit-item-from3", item._id, this.item_from3);
    },
    showEditInStock(item, state = false) {
      this.item_in_stock = item.in_stock;
      this.$emit("show-edit-in-stock", item._id, state);
    },
    showEditMxik(item, state = false) {
      this.item_mxik = item.mxik;
      this.$emit("show-edit-mxik", item._id, state);
    },
    showEditNDS(item, state = false) {
      this.item_nds_value = item.nds_value;
      this.$emit("show-edit-nds-value", item._id, state);
    },
    showEditReminder(item, state = false) {
      this.item_reminder = item.reminder;
      if (item.count_by_type) {
        this.item_count_by_type = item.count_by_type;
      } else {
        this.item_count_by_type = 0;
      }
      this.$emit("show-edit-reminder", item._id, state);
    },
    editItemInStock(item) {
      this.$emit("edit-item-in-stock", item._id, this.item_in_stock);
    },
    editItemMxik(item) {
      this.$emit("edit-item-mxik", item._id, this.item_mxik);
    },
    editItemNDS(item) {
      this.$emit("edit-item-nds-value", item._id, this.item_nds_value);
    },
    editItemReminder(item) {
      this.$emit("edit-item-reminder", item._id, this.item_reminder);
    },
    openVariants(item, state) {
      this.$emit("open-variants", item, state);
    },
    openVariantDialog(item) {
      this.$emit("open-variant-dialog", item);
    },
    includes(item) {
      return this.selected.includes(item);
    },
    activated(items) {
      this.activate(items, this.item_id);
      this.categoryMenu = false;
    },
    activateCurrent(item) {
      if (item) {
        this.item_id = item._id;
      }
    },
    activate(items, id) {
      if (items.length > 0) {
        this.active = items[items.length - 1];
        if (!this.map[this.active]) {
          for (const categ of this.all_plus_children_categories) {
            if (categ.children.length > 0) {
              for (const child of categ.children) {
                if (child._id == this.active) {
                  this.map[this.active] = {
                    id: child._id,
                    name: child.name,
                    type: child.type,
                  };
                }
              }
            }
            if (categ._id == this.active) {
              this.map[this.active] = {
                id: categ._id,
                name: categ.name,
                type: categ.type,
              };
            }
          }
        }
        if (this.map[this.active]) {
          for (let i = 0; i < this.data.length; i++) {
            if (this.data[i]._id == id && this.access.item_edit) {
              this.$emit("edit-item-category", id, this.map[this.active]);
            }
          }
        }
      }
    },
    async refresh() {
      const id = this.$route.query["id"];
      if (this.map[id]) {
        this.params.name = this.map[id].name;
        if (this.map[this.map[id].type]) {
          this.active = this.map[this.map[id].type]._id;
          this.params.category.name = this.map[this.map[id].type].name;
        }
      }
    },
    link(target) {
      if (target == "create") {
        return this.to + "/create";
      }
      if (target == "update") {
        if (this.view) return this.to + "/view";
        return this.to + "/update";
      }
      return this.to;
    },
    typing(item, item_row = true) {
      if (
        !this.Fees &&
        (!this.itemsView || item_row == false) &&
        !this.itemsMark
      ) {
        if (this.row) this.row(item);
        if (item !== null) this.dialog = true;
        if (this.to) {
          this.$router.push({
            path: this.link("update"),
            query: { id: item._id },
          });
        }
        if (this.toSupplier) {
          this.$router.push({
            path: this.toSupplier,
          });
          this.$emit("rowClicked", item);
        }
        if (this.itemsView) {
          this.$emit("itemClicked", item);
        }
      }
    },
    async saving() {
      this.loading_crud = true;
      if (this.save) {
        await this.save();
      }
      this.loading_crud = false;
      this.dialog = false;
    },
    removing() {
      if (this.remove) this.remove(this.selected);
      this.selected = [];
    },
    getColor(status) {
      if (status == "pending") return "#E95E62";
      else return "#45B69F";
    },
  },
  beforeMount() {
    this.access = this.$store.state.access;
  },
  computed: {
    computed_headers() {
      if (this.Itemss) {
        this.$store.commit("serItemListHeaders", this.headers);
      }
      const headers = [];
      for (const index in this.headers) {
        if (this.headers[index].available) {
          headers.push(this.headers[index]);
        }
      }
      return headers;
    },
  },
  mounted() {
    this.refresh();
    this.pagination_value = this.value;
    this.limit_value = this.limit;
    if (this.itemsView) {
      this.categorySortedByPosition();
    }
  },
};
</script>

<style>
.right-input input {
  text-align: right;
}
.text-field {
  width: 250px;
}
</style>
